import Vue from 'vue'
import {Dictionary, Module} from 'vuex'
import {RootState, MailingState} from '@/types/store/states'
import {RawMailing} from '@/types/entity/RawMailing'
import {RawRecipient} from '@/types/entity/RawRecipient'
import Mailing from '@/models/mailing/mailing'
import Recipient from '@/models/mailing/recipient'
import $store from '@/store'
import {API} from '@/constants'


const store: Module<MailingState, RootState> = {
  namespaced: true,
  state: {
    mailings: {},
    recipients: {}
  },
  getters: {
    getMailing: state => (data: RawMailing) => {
      if (state.mailings[data.id]) {
        state.mailings[data.id].setData(data)
      } else {
        Vue.set(state.mailings, data.id, new Mailing(data))
      }
      return state.mailings[data.id]
    },
    getMailings: (state, getters) => (mailingsData: RawMailing[], returnArray: boolean = true) => {
      const result = returnArray ? [] : {};
      for (const mailingData of mailingsData) {
        const mailing = getters.getMailing(mailingData);
        if (returnArray) {
          (result as Mailing[]).push(mailing);
        } else {
          (result as { [userId: string]: Mailing })[mailing.getId()] = mailing;
        }
      }
      return result;
    },
    getRecipient: state => (data: RawRecipient) => {
      if (state.recipients[data.id]) {
        state.recipients[data.id].setData(data)
      } else {
        Vue.set(state.recipients, data.id, new Recipient(data))
      }
      return state.recipients[data.id]
    },
    getRecipients: (state, getters) => (recipientsData: RawRecipient[], returnArray: boolean = true) => {
      const result = returnArray ? [] : {};
      for (const recipientData of recipientsData) {
        const recipient = getters.getRecipient(recipientData);
        if (returnArray) {
          (result as Recipient[]).push(recipient);
        } else {
          (result as { [userId: string]: Recipient })[recipient.getId()] = recipient;
        }
      }
      return result;
    }
  },
  mutations: {
  },
  actions: {
    async create (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.mailing.create,
        data
      }, {root: true})
      return response;
    },
    async get (context, id) {
      const response = await context.dispatch('apiRequest', {
        method: API.mailing.get,
        data: {mailing_id: id},
        flag: 'silent'
      }, {root: true})
      return context.getters.getMailing(response);
    },
    async update (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.mailing.update,
        data
      }, {root: true})
      return response;
    },
    async setReady (context, id) {
      const response = await context.dispatch('apiRequest', {
        method: API.mailing.setReady,
        data: {mailing_id: id}
      }, {root: true})
      return response;
    },
    async setDraft (context, id) {
      const response = await context.dispatch('apiRequest', {
        method: API.mailing.setDraft,
        data: {mailing_id: id}
      }, {root: true})
      return response;
    },
    async find (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.mailing.find,
        data,
        flag: 'silent'
      }, {root: true})
      return {mailings: context.getters.getMailings(response.mailings), count: response.total || 0};
    },
    async addFilter (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.mailing.rcptAddFilter,
        data,
        flag: 'ignoreTimeout'
      }, {root: true})
      return response;
    },
    async removeFilter (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.mailing.rcptRemoveFilter,
        data
      }, {root: true})
      return response;
    },
    async addIds (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.mailing.rcptAddIds,
        data,
        flag: 'ignoreTimeout'
      }, {root: true})
      return response;
    },
    async removeIds (context, data) {
      const response = await context.dispatch('apiRequest', {
        method: API.mailing.rcptRemoveIds,
        data
      }, {root: true})
      return response;
    },
    async rcptFind (context, query) {
      const response = await context.dispatch('apiRequest', {
        method: API.mailing.rcptFind,
        data: query,
        flag: 'silent'
      }, {root: true})
      return {rcpts: context.getters.getRecipients(response.rcpts), count: response.total}
    },
    async delete (context, id) {
      const response = await context.dispatch('apiRequest', {
        method: API.mailing.delete,
        data: {mailing_id: id}
      }, {root: true})
      return response;
    },
    async cancel (context, id) {
      const response = await context.dispatch('apiRequest', {
        method: API.mailing.cancel,
        data: {mailing_id: id}
      }, {root: true})
      return response;
    },
    async resend (context, id) {
      const response = await context.dispatch('apiRequest', {
        method: API.mailing.resend,
        data: {mailing_id: id}
      }, {root: true})
      return response;
    },
    async send_now (context, id) {
      const response = await context.dispatch('apiRequest', {
        method: API.mailing.send_now,
        data: {mailing_id: id}
      }, {root: true})
      return response;
    },
  }
}

export default store
